<template>
  <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <FormItem prop="userName">
		<Input v-model="form.userName" placeholder="请输入用户名">
			<span slot="prepend">
				<Icon :size="16" type="ios-person"></Icon>
			</span>
		</Input>
    </FormItem>
    <FormItem prop="password">
		<Input type="password" v-model="form.password" placeholder="请输入密码">
			<span slot="prepend">
				<Icon :size="14" type="md-lock"></Icon>
			</span>
		</Input>
    </FormItem>
    <!-- <FormItem prop="captcha" class="captchaBox">
		<Input type="text" v-model="form.captcha" class="captchaval" placeholder="请输入验证码"></Input>
		<div class="captcha">
			<img :src="captchaSrc" @click="getCaptcha">
		</div>
    </FormItem> -->
    <FormItem>
      	<Button @click="handleSubmit" type="primary" long>登录</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: "ManagementLoginForm",
  props: {
    userNameRules: {
		type: Array,
		default: () => {
			return [{ required: true, message: "账号不能为空", trigger: "blur" }];
		}
    },
    passwordRules: {
		type: Array,
		default: () => {
			return [{ required: true, message: "密码不能为空", trigger: "blur" }];
		}
    },
    // captchaRules: {
	// 	type: Array,
	// 	default: () => {
	// 		return [{ required: true, message: "验证码不能为空", trigger: "blur" }];
	// 	}
    // }
  },
  data() {
    return {
		form: {
			userName: "",
			password: "",
			// captcha: "",
			uuid: ""
		},
		captchaSrc: ""
    };
  },
  computed: {
    rules() {
      return {
        userName: this.userNameRules,
        password: this.passwordRules,
        captcha: this.captchaRules
      };
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$emit("on-success-valid", {
            username: this.form.userName,
            password: this.form.password,
            // captcha: this.form.captcha,
            // uuid: this.form.uuid
          });
        }
      });
    },
    // getCaptcha() {
    //   let data = this.getUUID();
    //   this.form.uuid = data;
    //   this.$api.login.getCaptcha(data).then(res => {
    //     this.captchaSrc =
    //       "http://192.168.0.243:8080/renren-fast" + `/captcha.jpg?uuid=${data}`;
    //   });
    // },
    getUUID() {
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
			return (c === "x"? (Math.random() * 16) | 0: "r&0x3" | "0x8").toString(16);
		});
    }
  },
  mounted() {
    // this.getCaptcha();
  }
};
</script>

<style lang="scss" scoped>
.captcha {
  width: 100px;
  height: 32px;
  float: right;
  img {
    width: 100px;
    height: 32px;
  }
}
.captchaval {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginForm.vue